import React from 'react';
import {CartItemDataHook} from '../../CartItem';
import s from '../../CartItem.scss';
import {LineItemModel} from '../../../../../../domain/models/LineItems/LineItem.model';
import {useTranslation} from '@wix/yoshi-flow-editor';
import {getLineItemSubscriptionFrequencyText} from '../../../../../../domain/utils/getLineItemSubscriptionFrequencyText';
import {SkeletonLineWrapper} from '../../../../Skeleton/SkeletonLine/SkeletonLineWrapper';
import {SkeletonRow} from '../../../../Skeleton/SkeletonRow/SkeletonRow';
import {Skeleton} from '../../../../Skeleton/Skeleton';

export const TotalPrice = ({lineItem, isItemLoading}: {lineItem: LineItemModel; isItemLoading: boolean}) => {
  const shouldDisplayFrequency =
    lineItem.attributes.subscriptionInfo &&
    lineItem.attributes.subscriptionInfo.subscriptionSettings.billingCycles !== 1;

  const {t} = useTranslation();

  if (isItemLoading) {
    return (
      <Skeleton dataHook={CartItemDataHook.totalPriceSkeleton} className={s.totalPrice}>
        <SkeletonRow>
          <SkeletonLineWrapper size="small" colorOverrideVariant="itemPrice" />
        </SkeletonRow>
      </Skeleton>
    );
  }

  return (
    <div className={s.totalPrice} data-hook={CartItemDataHook.TotalPrice}>
      <div className={s.priceRow}>
        {lineItem.pricing.breakdown.comparePrice?.formattedConvertedAmount && (
          <div
            data-hook={CartItemDataHook.ComparePriceOnLineItem}
            className={s.comparePrice}
            data-wix-line-item-crossed-out-price={CartItemDataHook.ComparePriceOnLineItem}>
            {lineItem.pricing.breakdown.comparePriceByQuantity.formattedConvertedAmount}
          </div>
        )}
        <div className={s.totalPriceText} data-wix-item-total-price={CartItemDataHook.TotalPrice}>
          {lineItem.pricing.totalPrice.formattedConvertedAmount}
        </div>
      </div>
      {shouldDisplayFrequency && (
        <div className={s.subscriptionFrequency} data-hook={CartItemDataHook.SubscriptionFrequency}>
          {getLineItemSubscriptionFrequencyText(t, lineItem.attributes.subscriptionInfo.subscriptionSettings)}
        </div>
      )}
    </div>
  );
};
